import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=9ac5989a&"
import script from "./SideNavbar.vue?vue&type=script&lang=js&"
export * from "./SideNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports